<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import { DACH_COUNTRY_OPTIONS } from "../../../../../../../../../_shared/_logic/countries"

  import type { PropertyFormModel } from "./_logic/types"

  type Props = {
    data: PropertyFormModel
    updateData: (next: Partial<PropertyFormModel>) => void
    disabled?: boolean
    fieldIds?: Partial<Record<keyof PropertyFormModel, string>>
  }

  let { data, updateData, disabled = false, fieldIds = {} }: Props = $props()
</script>

<div class="property-form">
  <section class="row">
    <Input id={fieldIds.street} placeholder="Straße" bind:value={data.street} {disabled} />
    <Input
      id={fieldIds.house_number}
      placeholder="Hausnummer"
      bind:value={data.house_number}
      {disabled}
    />
  </section>
  <section class="row">
    <Input id={fieldIds.zip} placeholder="PLZ" bind:value={data.zip} {disabled} />
    <Input id={fieldIds.city} placeholder="Ort" bind:value={data.city} {disabled} />
  </section>
  <section class="row">
    <Input
      id={fieldIds.country}
      type="select"
      placeholder="Land"
      options={DACH_COUNTRY_OPTIONS}
      bind:value={data.country}
      brightBackground={true}
      {disabled}
    />
    <Input
      id={fieldIds.address_extra}
      placeholder="Adresszusatz"
      bind:value={data.address_extra}
      {disabled}
    />
  </section>
</div>

<style lang="less">
  .property-form {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 0.75rem;
  }
</style>
